import { jsx as t } from "react/jsx-runtime";
import "../../forms/Button/Button.mjs";
import { IconButton as a } from "../../forms/Button/IconButton.mjs";
import "../../forms/Button/ButtonGroup.mjs";
import { ChevronDownIcon as n } from "../../icons/componentIcons.mjs";
const p = ({
  onClick: r,
  "aria-label": i,
  isExpanded: o = !1
}) => /* @__PURE__ */ t(
  a,
  {
    onClick: r,
    "aria-label": i,
    variant: "ghost",
    size: "sm",
    icon: /* @__PURE__ */ t(
      n,
      {
        variant: "light",
        size: "md",
        rotation: o ? 180 : void 0,
        style: { transition: "transform .2s ease" }
      }
    ),
    role: "switch",
    "aria-checked": o
  }
);
export {
  p as ExpandRowIconButton
};
